<!--
  ~ Copyright 2022-2026 NXGN Management, LLC. All Rights Reserved.
  -->

<div id="merchantDetail">
  <div>
    <h1>Merchant Detail</h1>
    <div *ngIf="loaded">
      <div
        *ngIf="
          isWorldPay() &&
          !merchant.accountDetails.worldPayAccountDetails
            .backingWPMerchantExists
        "
      >
        <div class="alert alert-danger" role="alert">
          No data from WP, please try again later.
        </div>
      </div>

      <div class="mb-2">
        <span
          class="btn btn-danger mr-1"
          *ngIf="hasFinanceRole() && isMerchantActive()"
          (click)="updateStatus('INACTIVE')"
        >
          <span>
            <fa-icon [icon]="faRetweet"></fa-icon>
          </span>
          Deactivate
        </span>
        <span
          class="btn btn-primary mr-1"
          *ngIf="hasFinanceRole() && !isMerchantActive()"
          (click)="updateStatus('ACTIVE')"
        >
          <span>
            <fa-icon [icon]="faRetweet"></fa-icon>
          </span>
          Reactivate
        </span>

        <span
          class="btn btn-success"
          *ngIf="
            hasFinanceRole() &&
            isMerchantActive() &&
            !isInstaMed() &&
            !merchantService.isGlobalPayments(merchant)
          "
          (click)="updateStatus('TEST')"
        >
          <span>
            <fa-icon [icon]="faRetweet"></fa-icon>
          </span>
          Set Status to Test
        </span>
      </div>
    </div>
  </div>

  <div *ngIf="!loaded">
    <div>
      <app-load-spinner></app-load-spinner>
    </div>
  </div>
  <div *ngIf="loaded">
    <mat-tab-group>
      <div *ngIf="isWorldPay()">
        <mat-tab label="Payment Processor Info">
          <app-payment-processor-info
            [merchant]="merchant"
          ></app-payment-processor-info>
        </mat-tab>
        <mat-tab label="General Info">
          <app-wp-general-info [merchant]="merchant"></app-wp-general-info>
        </mat-tab>
        <mat-tab label="Customer Contact Info" *ngIf="!isInstaMed()">
          <app-wp-customer-contact
            [merchant]="merchant"
          ></app-wp-customer-contact>
        </mat-tab>
        <mat-tab label="Address" *ngIf="!isInstaMed()">
          <app-wp-merchant-address
            [merchant]="merchant"
          ></app-wp-merchant-address>
        </mat-tab>
        <mat-tab label="Legal Entity" *ngIf="!isInstaMed()">
          <app-wp-legal-entity [merchant]="merchant"></app-wp-legal-entity>
        </mat-tab>
        <mat-tab label="Beneficial Owner" *ngIf="isWorldPay()">
          <app-beneficial-owner [merchant]="merchant"></app-beneficial-owner>
        </mat-tab>
        <mat-tab label="Bank Account Details" *ngIf="isWorldPay()">
          <app-account-details [merchant]="merchant"></app-account-details>
        </mat-tab>
      </div>
      <div
        *ngIf="
          !isWorldPay() &&
          !isInstaMed() &&
          !merchantService.isGlobalPayments(merchant)
        "
      >
        <mat-tab label="Merchant Details">
          <app-not-wp-merchant-details
            [merchant]="merchant"
          ></app-not-wp-merchant-details>
        </mat-tab>
      </div>
      <div *ngIf="isInstaMed() || merchantService.isGlobalPayments(merchant)">
        <mat-tab label="Merchant Details">
          <app-payment-processor-general-info
            [merchant]="merchant"
          ></app-payment-processor-general-info>
        </mat-tab>
      </div>
      <mat-tab label="PayPal Account Details" *ngIf="isPaypal()">
        <app-pay-pal-details [merchant]="merchant"></app-pay-pal-details>
      </mat-tab>
      <mat-tab label="InstaMed Account Details" *ngIf="isInstaMed()">
        <app-instamed-details
          [loaded]="loaded"
          [merchant]="merchant"
        ></app-instamed-details>
      </mat-tab>
      <mat-tab
        label="Global Payments Account Details"
        *ngIf="merchantService.isGlobalPayments(merchant)"
      >
        <app-global-payments-details
          [merchant]="merchant"
        ></app-global-payments-details>
      </mat-tab>
      <mat-tab label="QBPay Account Details" *ngIf="isQbpay()">
        <app-qbpay-details
          [loaded]="loaded"
          [merchant]="merchant"
        ></app-qbpay-details>
      </mat-tab>
      <mat-tab label="E-Statement Options" *ngIf="isWorldPay()">
        <app-e-statement-options
          [merchant]="merchant"
        ></app-e-statement-options>
      </mat-tab>
      <mat-tab
        label="User and Roles"
        *ngIf="!isInstaMed() && !merchantService.isGlobalPayments(merchant)"
      >
        <app-users-and-roles [merchant]="merchant"></app-users-and-roles>
      </mat-tab>
      <mat-tab
        label="Partners"
        *ngIf="
          (hasFinanceRole() || hasImplementationRole()) &&
          !isInstaMed() &&
          !merchantService.isGlobalPayments(merchant)
        "
      >
        <app-partners [merchant]="merchant"></app-partners>
      </mat-tab>
      <mat-tab
        label="Chargebacks"
        *ngIf="!isInstaMed() && !merchantService.isGlobalPayments(merchant)"
      >
        <app-chargebacks [merchant]="merchant"></app-chargebacks>
      </mat-tab>
      <mat-tab label="Frauds And Risk" *ngIf="isWorldPay()">
        <app-fraud-and-risk [merchant]="merchant"></app-fraud-and-risk>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
